import React, { useState, useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import { Select, MenuItem } from "@mui/material";
import { AssignmentRowDtoWithKey } from "../../../../../../models/AssignmentRowDtoWithKey";

const ModificationMarkupOrMinimumAssignment = ({
  rowData,
  onChange,
}: {
  rowData: AssignmentRowDtoWithKey;
  onChange: any;
}) => {
  let markup = { markup: "", minimum: "" };
  try {
    markup = JSON.parse(
      rowData?.modificationValue ?? '{"markup": "", "minimum": ""}',
    );
  } catch (ex) {}

  const [markupAmount, setMarkupAmount] = useState<string | number>(
    markup.markup,
  );
  const [minimumAmount, setMinimumAmount] = useState<string | number>(
    markup.minimum,
  );

  useEffect(() => {
    const modification = JSON.stringify({
      markup: markupAmount?.toString(),
      minimum: minimumAmount?.toString(),
    });
    onChange(modification);
  }, [markupAmount, minimumAmount]);

  return (
    <Grid item>
      <TextField
        id="standard-basic"
        type="number"
        value={markupAmount}
        onChange={(event) => setMarkupAmount(event.target.value)}
        sx={{
          width: "100px",
          fieldset: { borderColor: "info.main" },
          mr: 2,
        }}
        InputProps={{
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        }}
      />

      <TextField
        id="standard-basic"
        type="number"
        value={minimumAmount}
        onChange={(event) => setMinimumAmount(event.target.value)}
        sx={{
          width: "100px",
          fieldset: { borderColor: "info.main" },
          mr: 2,
        }}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        }}
      />
    </Grid>
  );
};

export default ModificationMarkupOrMinimumAssignment;
